export const SURVEY_PATH = "/my-surveys/:id";
